import React from 'react';
import { usePermissions } from '../hooks/usePermissions';
import Companies from './Companies';

const CompaniesPage: React.FC = () => {
  const { canView, canAdd, canEdit, canDelete } = usePermissions();

  if (!canView('companies')) {
    return null;
  }

  return (
    <Companies
      canAdd={canAdd('companies')}
      canEdit={canEdit('companies')}
      canDelete={canDelete('companies')}
    />
  );
};

export default CompaniesPage; 